import { render } from "./BasketContent.vue?vue&type=template&id=a00f43f0"
import script from "./BasketContent.vue?vue&type=script&lang=js"
export * from "./BasketContent.vue?vue&type=script&lang=js"

import "./BasketContent.vue?vue&type=style&index=0&id=a00f43f0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__